import { render, staticRenderFns } from "./BottomInfo.vue?vue&type=template&id=246f06ee&scoped=true&"
import script from "./BottomInfo.vue?vue&type=script&lang=js&"
export * from "./BottomInfo.vue?vue&type=script&lang=js&"
import style0 from "./BottomInfo.vue?vue&type=style&index=0&id=246f06ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246f06ee",
  null
  
)

export default component.exports